import type { DashboardSummary } from "../types/dashboard";
import { apiClient, API_ENDPOINTS } from "../../../config/api";

export async function getDashboard(): Promise<DashboardSummary> {
  const response = await apiClient.get<{ result: any; resultType: string }>(
    API_ENDPOINTS.DASHBOARD.SUMMARY
  );
  
  if (response.resultType !== 'SUCCESS') {
    throw new Error("대시보드 데이터를 불러오지 못했습니다.");
  }
  
  // API 응답을 클라이언트 모델로 변환
  return transformDashboardResponse(response.result);
}

function transformDashboardResponse(apiData: any): DashboardSummary {
  return {
    user: {
      userId: apiData.user.userId,
      userName: apiData.user.userName,
      profileCompletionPercent: apiData.user.profileCompletionPercent
    },
    wallet: apiData.wallet,
    notifications: apiData.notifications,
    nextDrop: apiData.nextDrop,
    cupidCards: apiData.cupidCards.map(transformCard),
    missions: apiData.missions,
    activity: apiData.activity
  };
}

function transformCard(card: any) {
  const now = new Date();
  const fallbackExpiresAt = new Date(now.getTime() + (card.remainingDays ?? 7) * 24 * 60 * 60 * 1000).toISOString();
  const fallbackExtendDeadlineAt = new Date(now.getTime() + ((card.remainingDays ?? 7) + 3) * 24 * 60 * 60 * 1000).toISOString();

  return {
    cardId: card.cardId,
    status: card.status,
    remainingDays: card.remainingDays,
    isExtendable: card.isExtendable,
    openCostHearts: card.openCostHearts,
    extendCostHearts: card.extendCostHearts,
    expiresAt: card.expiresAt ?? fallbackExpiresAt,
    extendDeadlineAt: card.extendDeadlineAt ?? fallbackExtendDeadlineAt,
    extendCount: card.extendCount ?? 0,
    isMutual: card.isMutual ?? false,
    chatDeadline: card.chatDeadline ?? null,
    thumbnailImage: card.thumbnailImage,
    cardPreview: card.cardPreview,
  };
}